import { fKeyTabInput } from "../../../Utility/Utilitys";
import {
  CmpTextField,
  CmpTextFieldEnter,
  CmpSelectBox,
  CmpTypographyField,
  CmpDatePicker,
} from "../../../Component/Common/ToolBox/ToolBox";
import Grid from "@mui/material/Grid";
import { BarcodeFlag } from "../PutAwayAction";
import { CmpTextFieldV1 } from "../../../Component/Common/ToolBox/ToolBoxV1";
import GCToggleSearchV1 from "../../../Component/Common/ReuseableComponent/GCToggleSearchV1";
export default function WmsContent({
  sEnterKeyObj,
  vMediaQuery,
  xContent_Focus,
  xContent_Blur,
  xErrorMsgDetail,

  xBufferObj,
  sUnit,

  fUnit,
  fQty,
  fQty_Enter,
  fCardId,
  fCardIdEnter,
  fBarcode,
  fBarcodeEnter,
  fItemName,
  fExpDate,
  //toggle
  xMediaQuery,
  xonClickbtn,
  xrows,
  xcolumns,
  xRowCellClick,
  xRowClick,
  xToggle,
  xData,
  xOnChangeDropdownInput,
  xDropdownObj,
  xOnKeyUpDropdownInput,

  //customer
  xfGC_Toggle_Head_BinName_Name,
  xGC_Toggle_Head_BinName_Toggle = false,
  xGC_Toggle_Head_BinName_onKeyUp,
  xGC_Toggle_Head_BinName_SearchDropdownObj,
  xGC_Toggle_Head_BinName_Dropdown_onChange,
  xGC_Toggle_Head_BinName_Dropdown_OnKeyUp_Load,
  xGC_Toggle_Head_BinName_GridColumns,
  xGC_Toggle_Head_BinName_GridData,
  xfGC_Toggle_Head_BinName_OnRowClick,
  xfGC_Toggle_Head_BinName_OnCellKeyDown,
  xGC_Toggle_Head_BinName_DropDown_Arr,
  //customer end
}) {
  return (
    <form
    // className="Wms-inbound-grn-content mt-4"
    // id="WmsStockAdjustmentContent"
    >
      <Grid
        container
        spacing={1}
        columns={{ xs: 12, sm: 12, md: 12 }}
        className="mb-1"
      >
        <Grid item xs={"auto"} sm={"auto"} md={"auto"}>
          <CmpTypographyField
            xcomponent={"span"}
            xText={"RefNo=" + xBufferObj.SuppRefNo1}
          />
        </Grid>
      </Grid>
      <Grid
        container
        spacing={{ xs: 2, sm: 1, md: 2 }}
        columns={{ xs: 12, sm: 12, md: 12 }}
        className="stock-detail mt-2"
      >
        <Grid item xs={4} sm={1.5} md={4}>
          <CmpTextField
            xLabelText={"Sr.No"}
            xVariant={"outlined"}
            xValue={xBufferObj.B_Srno}
            xType={"text"} // text/number/password
            xName={"B_Srno"}
            xReadOnly={true}
            xOnChange={""}
            xError={xErrorMsgDetail.B_Srno === "" ? false : true}
            xErrorMessage={xErrorMsgDetail.B_Srno}
          />
        </Grid>
        <Grid item xs={8} sm={2.5} md={BarcodeFlag() ? 4 : 8}>
          <CmpTextFieldEnter
            xLabelText={"Card ID"}
            xVariant={"outlined"}
            xValue={xBufferObj.B_CardId}
            xType={"text"} // text/number/password
            xName={"B_CardId"}
            xReadOnly={false}
            xOnChange={fCardId}
            xError={xErrorMsgDetail.B_CardId === "" ? false : true}
            xErrorMessage={xErrorMsgDetail.B_CardId}
            xtabIndex={"101"}
            xOnKeyUp={fCardIdEnter}
            xOnEnter={(e) => {
              fCardIdEnter(sEnterKeyObj);
            }}
            xSmShow={!!vMediaQuery}
          />
        </Grid>
        <Grid
          item
          xs={12}
          sm={2.5}
          md={4}
          className={BarcodeFlag() ? "" : "hide-all-time"}
        >
          <CmpTextFieldEnter
            xLabelText={"Barcode"}
            xVariant={"outlined"}
            xValue={xBufferObj.B_Barcode}
            xType={"text"} // text/number/password
            xName={"B_Barcode"}
            xReadOnly={false}
            xOnChange={fBarcode}
            xError={xErrorMsgDetail.B_Barcode === "" ? false : true}
            xErrorMessage={xErrorMsgDetail.B_Barcode}
            xtabIndex={"101"}
            xOnKeyUp={fBarcodeEnter}
            xOnEnter={(e) => {
              fBarcodeEnter(sEnterKeyObj);
            }}
            xSmShow={!!vMediaQuery}
          />
        </Grid>
        <Grid item xs={4} sm={2.5} md={4}>
          <CmpTextField
            xLabelText={"Item Code"}
            xVariant={"outlined"}
            xValue={xBufferObj.B_Itmcd}
            xType={"text"} // text/number/password
            xName={"B_Itmcd"}
            xReadOnly={true}
            xOnChange={""}
            xError={xErrorMsgDetail.B_Itmcd === "" ? false : true}
            xErrorMessage={xErrorMsgDetail.B_Itmcd}
          />
        </Grid>
        <Grid item xs={8} sm={5.5} md={8}>
          <CmpTextField
            xLabelText={"Item Name"}
            xVariant={"outlined"}
            xValue={xBufferObj?.B_ItmName}
            xOnChange={fItemName}
            xReadOnly={true}
            xType={"text"}
            xName={"B_ItmName"}
            xError={xErrorMsgDetail.B_ItmName === "" ? false : true}
            xErrorMessage={xErrorMsgDetail.B_ItmName}
            xtabIndex={"102"}
          />
        </Grid>
        <Grid item xs={4} sm={2} md={4}>
          {/* <CmpTextField
            xLabelText={"Bin No"}
            xVariant={"outlined"}
            xValue={xBufferObj.B_BinCode}
            xType={"text"} // text/number/password
            xName={"B_BinCode"}
            xReadOnly={true}
            xOnChange={""}
            xError={xErrorMsgDetail.B_BinCode === "" ? false : true}
            xErrorMessage={xErrorMsgDetail.B_BinCode}
          /> */}

          <CmpTextFieldV1
            xLabelText="Bin No"
            xValue={xBufferObj.B_BinCode}
            xType={"text"} // text/number/password
            xName={"B_BinCode"}
            xReadOnly={true}
            xOnChange={""}
            xError={xErrorMsgDetail.B_BinCode === "" ? false : true}
            xErrorMessage={xErrorMsgDetail.B_BinCode}
            xSx={{
              width: "100%",
              "& .MuiInputLabel-root": {
                top: "-5px !important",
                color: "#666 !important",
              },
              "& .MuiInputLabel-root.Mui-focused": {
                color: "#0d73bb !important",
              },
              "& .MuiInputLabel-shrink": { top: "0px !important" },
            }}
          />
        </Grid>
        <Grid item xs={8} sm={4} md={8}>
          {/* <CmpTextFieldEnter
            xtabIndex="103"
            xLabelText={"Bin Name"}
            xVariant={"outlined"}
            xValue={xBufferObj.B_BinName}
            xOnChange={xfGC_Toggle_Head_BinName_Name}
            xOnKeyUp={xGC_Toggle_Head_BinName_onKeyUp}
            xReadOnly={false}
            xType={"text"}
            xName={"GC_Toggle_Head_BinName_Name"}
            xError={xErrorMsgDetail.B_BinName === "" ? false : true}
            xErrorMessage={xErrorMsgDetail.B_BinName}
            xOnEnter={(e) => {
              xGC_Toggle_Head_BinName_onKeyUp(sEnterKeyObj);
            }}
            xSmShow={!!vMediaQuery}
          /> */}

          <GCToggleSearchV1
            xLabelText="Bin Name"
            xName={"GC_Toggle_Head_BinName_Name"}
            xType={"text"}
            xValue={xBufferObj.B_BinName}
            xReadOnly={false}
            xOnChange={xfGC_Toggle_Head_BinName_Name} //GCToggleSearch onchange main input
            xOnKeyUp={xGC_Toggle_Head_BinName_onKeyUp} //GCToggleSearch xOnKeyUp main input
            xError={xErrorMsgDetail.B_BinName === "" ? false : true}
            xErrorMessage={xErrorMsgDetail.B_BinName}
            xMediaQuery={false}
            xonClickbtn={xGC_Toggle_Head_BinName_onKeyUp} // GCToggleSearch onclick icon open div on main screen
            xrows={xGC_Toggle_Head_BinName_GridData} //GCToggleSearch-grid
            xcolumns={xGC_Toggle_Head_BinName_GridColumns} //GCToggleSearch-grid
            xRowCellClick={xfGC_Toggle_Head_BinName_OnCellKeyDown}
            xRowClick={xfGC_Toggle_Head_BinName_OnRowClick}
            xToggle={xGC_Toggle_Head_BinName_Toggle} //GCToggleSearch- true/false
            xData={xGC_Toggle_Head_BinName_DropDown_Arr} //GCToggleSearch-select
            xOnChangeDropdownInput={xGC_Toggle_Head_BinName_Dropdown_onChange} //GCToggleSearch -input
            xDropdownObj={xGC_Toggle_Head_BinName_SearchDropdownObj} //GCToggleSearch -obj
            xOnKeyUpDropdownInput={
              xGC_Toggle_Head_BinName_Dropdown_OnKeyUp_Load
            } //GCToggleSearch -Enter key and clickc detect
            xtabIndex="107"
            xSx={{
              width: "100%",
              "& .MuiInputLabel-root": {
                top: "-5px !important",
                color: "#666 !important",
              },
              "& .MuiInputLabel-root.Mui-focused": {
                color: "#0d73bb !important",
              },
              "& .MuiInputLabel-shrink": { top: "0px !important" },
            }}
          />
        </Grid>
        <Grid item xs={3} sm={1.5} md={2}>
          <CmpTextField
            xLabelText={"Qty"}
            xVariant={"outlined"}
            xtabIndex={"104"}
            xValue={xBufferObj.B_Qty}
            xType={"number"} // text/number/password
            xName={"B_Qty"}
            xReadOnly={false}
            xOnChange={fQty}
            xError={xErrorMsgDetail.B_Qty === "" ? false : true}
            xErrorMessage={xErrorMsgDetail.B_Qty}
            xOnKeyUp={fQty_Enter}
            xonFocus={(e) => {
              xContent_Focus(e);
            }}
            xonBlur={xContent_Blur}
          />
        </Grid>
        <Grid item xs={5.5} sm={2} md={6}>
          <CmpSelectBox
            xtabIndex={"105"}
            xLabelText="Unit"
            xVariant={"outlined"}
            xValue={xBufferObj.B_Unit}
            xOnChange={fUnit}
            xName={"unit"}
            xData={sUnit}
            xValueMember={""}
            xDispalyMember={""}
            xError={xErrorMsgDetail.B_Unit === "" ? false : true}
            xErrorMessage={xErrorMsgDetail.B_Unit}
            xDisable={false}
          />
        </Grid>
        <Grid item xs={3.5} sm={2.5} md={2}>
          <CmpTextField
            xLabelText={"Packing"}
            xVariant={"outlined"}
            xtabIndex={"107"}
            xValue={xBufferObj.B_Packing}
            xType={"text"} // text/number/password
            xName={"B_Packing"}
            xReadOnly={true}
            xOnChange={""}
            xError={xErrorMsgDetail.B_Packing === "" ? false : true}
            xErrorMessage={xErrorMsgDetail.B_Packing}
          />
        </Grid>
        <Grid item xs={3} sm={1.5} md={2}>
          <CmpTextField
            xLabelText={"Base Qty"}
            xVariant={"outlined"}
            xtabIndex={"107"}
            xValue={xBufferObj.B_BaseQty}
            xType={"text"} // text/number/password
            xName={"B_BaseQty"}
            xReadOnly={true}
            xOnChange={""}
            xError={xErrorMsgDetail.B_BaseQty === "" ? false : true}
            xErrorMessage={xErrorMsgDetail.B_BaseQty}
          />
        </Grid>
        <Grid item xs={5.5} sm={2.3} md={3}>
          <CmpTextField
            xLabelText={"BatchNo"}
            xVariant={"outlined"}
            xtabIndex={"107"}
            xValue={xBufferObj.B_BatchNo}
            xType={"text"} // text/number/password
            xName={"B_BatchNo"}
            xReadOnly={true}
            xOnChange={""}
            xError={xErrorMsgDetail.B_BatchNo === "" ? false : true}
            xErrorMessage={xErrorMsgDetail.B_BatchNo}
          />
        </Grid>
        <Grid item xs={3.5} sm={2} md={2}>
          <CmpTextField
            xLabelText={"Balance Qty"}
            xVariant={"outlined"}
            xtabIndex={"107"}
            xValue={xBufferObj.B_BalanceQty}
            xType={"text"} // text/number/password
            xName={"B_BalanceQty"}
            xReadOnly={true}
            xOnChange={""}
            xError={xErrorMsgDetail.B_BalanceQty === "" ? false : true}
            xErrorMessage={xErrorMsgDetail.B_BalanceQty}
          />
        </Grid>
        <Grid item xs={4} sm={1.7} md={2}>
          <CmpTextField
            xLabelText={"GRN Qty"}
            xVariant={"outlined"}
            xtabIndex={"107"}
            xValue={xBufferObj.B_GrnQty}
            xType={"text"} // text/number/password
            xName={"B_GrnQty"}
            xReadOnly={true}
            xOnChange={""}
            xError={xErrorMsgDetail.B_GrnQty === "" ? false : true}
            xErrorMessage={xErrorMsgDetail.B_GrnQty}
          />
        </Grid>
        <Grid item xs={4} sm={2} md={2}>
          <CmpTextField
            xLabelText={"PutAway Qty"}
            xVariant={"outlined"}
            xtabIndex={"107"}
            xValue={xBufferObj.B_PutAwayQty}
            xType={"text"} // text/number/password
            xName={"B_PutAwayQty"}
            xReadOnly={true}
            xOnChange={""}
            xError={xErrorMsgDetail.B_PutAwayQty === "" ? false : true}
            xErrorMessage={xErrorMsgDetail.B_PutAwayQty}
          />
        </Grid>
        <Grid item xs={4} sm={2.5} md={3}>
          <CmpDatePicker
            xLabelText={"Expiry Date"}
            xVariant={"outlined"}
            xtabIndex={"108"}
            xValue={xBufferObj.v_P_ExpDt}
            xType={"date"}
            xName={"v_P_ExpDt"}
            xReadOnly={false}
            xOnChange={(e) => {
              fExpDate(e);
            }}
            xError={xErrorMsgDetail.v_P_ExpDt === "" ? false : true}
            xErrorMessage={xErrorMsgDetail.v_P_ExpDt}
          />
        </Grid>
      </Grid>
    </form>
  );
}
